import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';
import { deleteRequest } from 'src/utils/request';
import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import messages from '../../messages';

const deleteFines = async ({ uuids }: { uuids: Array<string> }) => {
  const payload = {
    fine_uuids: uuids,
  };

  const { data } = await deleteRequest(API.DELETE.fines, {
    data: payload,
  });
  return data;
};

export const useDeleteFines = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: deleteFines,
    onSuccess: (res) => {
      client.invalidateQueries({ queryKey: [QUERY_KEYS.FINES] });
      handleSuccess(
        res?.data?.uuids?.length > 1
          ? formatMessage(messages.finesDeleted)
          : formatMessage(messages.fineDeleted),
      );
    },
    onError: handleError,
  });
};
